<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="false"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 :has-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-top-border-anchor-link="false"
                                 :has-movie-title="false"
                                 :has-movie="true"
    >
        <template v-if="hasCampaign" v-slot:content-campaign>
            <div class="information">
                <img :src="buildImgUrl('information_back.png')" alt="information">
                <a v-if="isShopSearchable" class="btn-shop" @click="transitionPage(shopSearchUrl, '遊べるお店はこちら', '_blank')"
                   data-jest="btn-shop">
                    <img :src="buildImgUrl('btn_shop.png')" alt="遊べるお店はこちら">
                </a>
                <a v-else class="btn-shop" @click="transitionPage('https://sp.pictlink.com/sp/puri_news#/17760', '撮れるお店はここ！', '_blank')"
                   data-jest="btn-shop-list">
                    <img :src="buildImgUrl('btn_shop_list.png')" alt="撮れるお店はここ！">
                </a>
            </div>
        </template>
        <template v-slot:feature-summary>
            <img :src="buildImgUrl('feature_summary.png')" alt="WataUsa2の基本情報">
        </template>
        <template v-slot:content-1>
            <div class="cont-01">
                <p class="img-01"><img :src="buildImgUrl('contents_01.png')" alt="みんな大好き♡ わたウサVer.1の写りもそのまま楽しめちゃう！"></p>
            </div>
        </template>
        <template v-slot:content-2>
            <div class="cont-02">
                <p class="img-01"><img :src="buildImgUrl('contents_02_01.png')" alt="女の子らしさがUPした可愛いすぎる写り"></p>
                <p class="img-02"><img :src="buildImgUrl('contents_02_02.png')" alt="ビビかわ盛れ くっきりだけど強すぎない可愛い盛れ感♡ キュンかわ盛れ 女の子らしさがUPした柔らかい可愛さ♡"></p>
            </div>
        </template>
        <template v-slot:content-3>
            <div class="cont-03">
                <p class="img-01"><img :src="buildImgUrl('contents_03_01.png')" alt="WataUsa2では…一度の撮影でビビかわ盛れの写りとキュンかわ盛れの写りをそれぞれ好きな枚数で選べるよ！"></p>
                <p class="img-02"><img :src="buildImgUrl('contents_03_02.gif')" alt="枚数選択イメージ"></p>
                <p class="img-03"><img :src="buildImgUrl('contents_03_03.png')" alt="例えば…こんな遊び方ができるよ！"></p>
            </div>
        </template>
        <template v-slot:content-4>
            <div class="cont-04">
                <p class="img-01"><img :src="buildImgUrl('contents_04_01.gif')" alt="ピクトリンクアプリと連携して楽しむ限定コース平成わたウサ盛れ ※2週間以内にわたウサ2で2回以上ピクトリンク連携をした人に限る"></p>
                <p class="img-02"><img :src="buildImgUrl('contents_04_02.png')" alt="写り・シール・背景・スタンプ イメージ"></p>
                <p class="img-03"><img :src="buildImgUrl('contents_04_03.gif')" alt="限定コースの遊び方"></p>
            </div>
        </template>
        <template v-slot:content-5>
            <div class="cont-05">
                <p class="img-01"><img :src="buildImgUrl('contents_05_01.png')" alt="可愛すぎるシール＆スタンプ新たに追加！"></p>
                <p class="img-02"><img :src="buildImgUrl('contents_05_02.png')" alt="パワーアップしたWataUsa2でさらに可愛いプリを楽しんでね！"></p>
            </div>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions, mapGetters} from "vuex";
import {getClickAllEvent} from "../../../util/Ga4EventUtil";

export default {
    name: "MachineWatausa2",
    components: { LayoutMachineIntroduction },
    data() {
        return {
            machineId: 173,
            sectionTitleList: [
                '1. 大人気にお応えして継続搭載♡ Ver.1のビビかわ盛れ',
                '2. 新登場！可愛いすぎる写り キュンかわ盛れ',
                '3. 両方の写りを選べて楽しい 新・写り枚数選択',
                '4. たくさん撮ってくれた子だけの 限定の写りと遊び方',
                '5. 選べる可愛さ さらにUP！ シール＆スタンプ',
            ],
            shopSearchUrl: urlUtil.servletUrlUtil.shopSearchUrl('WataUsa2')
        }
    },
    computed: {
        ...mapGetters({
            accountStatus: 'AccountStoreV2/accountStatus'
        }),
        /**
         * 「遊べるお店はこちら！」ボタン表示判定
         * 通常はpropsのisSearchableをLayoutMachineIntroduction.vueに渡して同コンポーネント側でボタンを表示しますが、
         * 今回は非表示にする＆information内に表示するイレギュラー仕様ため、下記実装になっています。
         * ・LayoutMachineIntroduction.vueにはfalseを渡す
         * ・isShopSearchableの値でinformation内のボタンの表示分けを制御
         * 2026-09-25以降でもisSearchableがfalse(筐体通信終了後など)の場合はfalseとする
         */
        isShopSearchable() {
            return this.isShopMapPeriod && this.isSearchable
        },
        /**
         * 「遊べるお店はこちら！」ボタンの表示期間(2026-09-25 00:00以降)であるかどうか
         * accountStatus未取得時はfalseとする
         *
         * @return {boolean} 2026-09-25 00:00以降であればtrue
         */
        isShopMapPeriod() {
            return !!this.accountStatus && this.accountStatus.timeTripDate.isAfterTime("2026-09-25T00:00:00")
        },
        /**
         * キャンペーン枠(content-campaign)を表示するかどうか
         * 2026-09-25 00:00以降かつpropsのisSearchableがfalse(筐体通信終了後など)の場合は、キャンペーン枠ごと非表示とする
         *
         * | 期間               | isSearchable | キャンペーン枠のボタン                   |
         * | ------------------ | ------------ | ---------------------------------------- |
         * | 〜2026-09-24       | -            | 撮れるお店はここ！(puri_news#/17760)     |
         * | 2026-09-25 00:00〜 | true         | 遊べるお店はこちら(プリ機検索マップ)     |
         * | 2026-09-25 00:00〜 | false        | なし(キャンペーン枠ごと非表示)           |
         *
         * @return {boolean} 表示する場合true
         */
        hasCampaign() {
            return !(this.isShopMapPeriod && !this.isSearchable)
        },
    },
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
        /**
         * GA4イベントを送信してから指定したページに遷移させる
         * @param {string} url elementUrl
         * @param {string} elementText elementText
         * @param {string} transitionTarget 別窓指定
         */
        transitionPage(url, elementText, transitionTarget) {
            getClickAllEvent(url, elementText)
            window.open(url, transitionTarget)
        },
    }
}
</script>

<style scoped lang="scss">
@use "../../../../scss/v2/base/variables";
@use "sass:math";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            background-color: variables.$color-white;

            .information {
                margin-top: -1px;
                position: relative;

                .btn-shop {
                    display: block;
                    position: absolute;
                    width: math.percentage(math.div(530px, $deviceWidth));
                    top: math.percentage(math.div(324px, $deviceWidth));
                    left: math.percentage(math.div(110px, $deviceWidth));
                }
            }

            .list-anchor-link-feature-summary {
                background-color: variables.$color-machine-watausa2-link-bg;

                .list-anchor-link {
                    padding-top: (variables.$grid-base * 1.5);

                    .img-link {
                        width: math.percentage(math.div(640px, $deviceWidth));
                    }

                    /**
                     * アンカーリンクの区切り線
                     */
                    a:not(:last-child) .img-link {
                        padding-bottom: 3px;
                        background-image: linear-gradient(
                            variables.$color-machine-watausa2-link-line,
                            variables.$color-machine-watausa2-link-line
                        );
                        background-repeat: no-repeat;
                        background-position: bottom center;
                        background-size: 90% 1px;
                    }
                }

                .feature-summary {
                    width: math.percentage(math.div(610px, $deviceWidth));
                    padding: variables.$grid-consistent 0 (variables.$grid-base) 0;
                    margin: auto;
                }
            }
        }
        &-contents {
            .accordion-inner {

                .cont-02 {
                    background: v-bind("buildStyleImgUrl('contents_02_back.png')");
                    background-size: cover;
                }

                .cont-03 {
                    position: relative;
                    background: v-bind("buildStyleImgUrl('contents_03_back.png')");
                    background-size: cover;

                    .img-02 {
                        position: absolute;
                        top: math.percentage(math.div(112px, $deviceWidth));
                    }
                }

                .cont-04 {
                    background: v-bind("buildStyleImgUrl('contents_04_back.png')");
                    background-size: cover;
                }

                .cont-05 {
                    background: v-bind("buildStyleImgUrl('contents_05_back.png')");
                    background-size: cover;
                }
            }
        }
        &-movie {
            padding: variables.$grid-consistent * 4 0 variables.$grid-consistent * 4;
            background-image: v-bind("buildStyleImgUrl('proof_back.png')");
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            &-btn-studio {
                width: math.percentage(math.div(430px, $deviceWidth));
                margin: auto;
            }
        }
    }
}

</style>
